/*
 * File: 考勤规则配置
 */
<template>
    <div class="ruleSettings-manage">
        <Paper class="ruleSettings-manage-paper">
            <el-tabs class="ruleSettings-list-tab-pane" v-model="activeTabs" @tab-remove="removeTab">
                <!-- 合同列表页 -->
                <el-tab-pane label="考勤配置规则" name="theList" ref="myPane">
                    <list-layout-paper>
                        <template slot="header-button">
                            <lotsButton
                                type="primary"
                                size="mini"
                                title="新增"
                                @click="createRule">
                                <span class="icon iconfont">&#xe66a;</span> 新增
                            </lotsButton>
                        </template>
                        <!-- 表格 -->
                        <template v-slot:list="{ tableHeight }">
                            <edit-table-box
                                ref="editTableBox"
                                key="attendanceRulesSettings"
                                v-loading="tableList.tableLoading"
                                :index="config.index"
                                :selection="config.selection"
                                :columns="config.columns"
                                :height="tableHeight"
                                :allowRowClick="false"
                                :tableData="tableList.totalData"
                                :actions="config.actions"
                                @btn-event="handleActive"
                            >
                                <template v-slot:col-append="{ item, row }">
                                    <p v-if="['time'].includes(item.prop)" class="addressName">
                                        {{ row['workStartTime'] }} - {{ row['workEndTime'] }}
                                    </p>
                                </template>
                            </edit-table-box>
                        </template>
                        <template slot="footer">
                            <lots-pagination
                                @size-change="tableList.sizeChange"
                                :current-page.sync="tableList.pageNo"
                                @current-change="tableList.pageChange"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="tableList.pageTotal" >
                            </lots-pagination>
                        </template>
                    </list-layout-paper>
                </el-tab-pane>

                <!-- 详情页签 -->
                <el-tab-pane
                    class="detail-pane"
                    closable
                    v-for="item in tabList"
                    :key="item.id"
                    :label="item.tagName"
                    :name="String(item.id)"
                >
                    <rulesSettingsForm :data="item" @createFinish="createFinish" />
                </el-tab-pane>

            </el-tabs>
        </Paper>
    </div>
</template>

<script>
import { ref, reactive, onMounted } from '@vue/composition-api';
import { Message, MessageBox } from 'element-ui';
import { handleDictionaryDataString, formatDictCodeToName } from '@/modules/mdm/utils.js';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import Paper from '@/components/core/Paper';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import lotsButton from '@/components/lots/lotsButton';
import editTableBox from '@/components/lots/editTableBox/Index';
import { getRuleList, deleteApi } from '@/api/attendanceRuleSettings.js';
import { config as configStatic } from './config';
import rulesSettingsForm from './form.vue';

export default {
    name: 'revenueFactor',
    components: {
        Paper,
        listLayoutPaper,
        lotsButton,
        editTableBox,
        lotsPagination,
        rulesSettingsForm
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const config = reactive(configStatic);

        const activeTabs = ref('theList');
        // 打开的详情tab页集
        const tabList = ref([]);
        // 删除详情标签
        const removeTab = (id) => {
            if (activeTabs.value === id) {
                activeTabs.value = 'theList';
            }
            tabList.value = tabList.value.filter(
                (tab) => String(tab.id) !== id
            );
        };

        /**
         * @description: 开详情页通用部分代码
         * @param {Object} data 页面数据对象
         * @param {String} name 页面名称信息
         *  */
        // eslint-disable-next-line complexity
        const newDetailPage = (type = 'add', name, data) => {
            if (tabList.value.length === config.PANELMAX) {
                return Message.warning('已超出8个详情页，请关闭后重新打开');
            }
            const params = {
                id: null,
                type,
                tagName: name,
                ...data
            };
            if (type === 'add') {
                // 3. 查找是否存在添加类型的标签页
                const existingAddTab = tabList.value.find(v => v.type === 'add');
                if (existingAddTab) {
                    // 4. 如果已存在，直接切换
                    activeTabs.value = String(existingAddTab.id);
                } else {
                    // 生成唯一时间戳ID（时间戳+随机数）
                    // 确保ID唯一,赋值给params.id
                    // 主要是为了tab标签切换识别，删除
                    const timestamp = Date.now();
                    const random = Math.floor(Math.random() * 1000); // 生成一个 0 到 999之间的随机整数
                    const uniqueId = `${timestamp}${random.toString().padStart(3, '0')}`; // padStart(3, '0') 确保始终是3位数字格式
                    params.id = uniqueId;
                    // 6. 更新活动标签页并添加到列表
                    activeTabs.value = uniqueId;
                    tabList.value.push(params);
                }
            }
            if (type === 'edit') {
                // 3. 查找是否已存在的标签页
                const existingTab = tabList.value.find(v => v.id === params.id);
                if (existingTab) {
                    // 4. 如果已存在，直接切换
                    activeTabs.value = String(existingTab.id);
                } else {
                    activeTabs.value = String(params.id);
                    // 设置标签页标题
                    params.tagName = params.ruleName;
                    tabList.value.push(params);
                }
            }
        };

        // 新增考勤配置规则
        const createRule = () => {
            newDetailPage('add', '新增考勤配置规则');
        };

        // 新增/编辑完成后刷新列表
        const createFinish = (data) => {
            // removeTab(String(data.id));
            tableList.getList();
        };

        // 考勤配置规则列表
        class ListClass extends AdvanceListClass {
            afterGetList (res) {
                if (+res.code === 0) {
                    this.totalData.value = res.data.list.map(v => {
                        if (v.depts.length) {
                            v.dept = v.depts.map(item => item.deptName).join('、');
                        } else {
                            v.dept = '';
                        }
                        return {
                            edit: -3,
                            ...v
                        }; ;
                    });
                    this.pageTotal.value = res.data.totalCount;
                }
                setupContext.root.$nextTick(() => {
                    setupContext.refs.editTableBox.$refs.moduleTable.doLayout(); // 解决表格错位
                });
            };
        }

        // 考勤配置规则列表
        const tableList = new ListClass({
            Api: {
                listApi: getRuleList // 查询接口
            }
        });

        // 操作项
        const handleActive = (row, event) => {
            // 编辑
            if (event === 'editOpera') {
                newDetailPage('edit', '编辑考勤配置规则', row);
            }
            // 删除
            if (event === 'delete') {
                deleteOpera(row);
            }
        };

        // 删除操作
        const deleteOpera = (row) => {
            MessageBox.confirm('此操作将删除 ' + row.ruleName + ' 考勤配置规则,是否继续？', '温馨提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                tableList.tableLoading.value = true;
                deleteApi(row.id).then(res => {
                    if (+res.code === 0) {
                        Message.success('删除成功');
                        tableList.getList();
                    }
                }).finally(() => {
                    tableList.tableLoading.value = false;
                });
            });
        };

        onMounted(() => {
            tableList.getList();
        });

        return {
            tableList,
            config,
            formatDictCodeToName,
            handleDictionaryDataString,
            handleActive,
            activeTabs,
            tabList,
            removeTab,
            createRule,
            createFinish
        };
    }
};
</script>

<style lang="less" >
    .ruleSettings-manage {
    width: 100%;

    .ruleSettings-manage-paper {
        height: 100%;
    }

    .list-layout-wrapper {
        height: 100%;
    }

    .ruleSettings-list-tab-pane.el-tabs {
        width: 100%;
        height: 100%;

        &>.el-tabs__content {
            height: calc(100% - 40px - 14px);
            overflow: auto;

            &>.el-tab-pane {
                overflow: auto;
                padding-right: 5px;
                height: 100%;

                .list-main {
                    .table-box {
                        height: 100%;
                    }
                }
            }
        }
    }

    .flex-layout .list-main {
        overflow: auto;
    }

    .list-layout .list-header .el-input {
        margin-left: 0;
    }

    .flex-layout .table {
        overflow-y: auto;
    }

    .list-header {
        .ruleSettings-manage-list-dropdown.el-dropdown {
            color: #fff;
        }
    }

    .layout-content.ruleSettings-manage-paper {
        padding: 0px 20px 20px;

        .el-table .cell.el-tooltip {
            &>div {
                width: 100%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }

    .list-layout-wrapper {
        padding: 0px;
    }
}

.ruleSettings-manage-list-dropdown-menu {
    background-color: #fff;
}

.column-config_title {
    font-size: 14px;
}
</style>
